export default __webpack_public_path__ + "static/media/bag.d5d829d3c3e83615d68f3db54b46aa1c.svg";